import React from 'react';
import { ShoppingBag, Mail, Facebook, Instagram, Twitter } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1e1919] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-gradient-to-br from-yellow-400 to-orange-400 rounded-full flex items-center justify-center">
                <ShoppingBag className="w-5 h-5 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold">Thinkkool</h3>
                <p className="text-xs text-[#bbb5ae] -mt-1">toys</p>
              </div>
            </div>
            <p className="text-[#bbb5ae] leading-relaxed">
              Bringing joy to children through carefully curated toys that inspire creativity and fun.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors duration-200"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors duration-200"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors duration-200"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-[#bbb5ae] hover:text-white transition-colors duration-200"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('categories')}
                  className="text-[#bbb5ae] hover:text-white transition-colors duration-200"
                >
                  Categories
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-[#bbb5ae] hover:text-white transition-colors duration-200"
                >
                  Products
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-[#bbb5ae] hover:text-white transition-colors duration-200"
                >
                  About Us
                </button>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-lg font-bold mb-4">Categories</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-[#bbb5ae] hover:text-white transition-colors duration-200"
                >
                  Fidgets
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-[#bbb5ae] hover:text-white transition-colors duration-200"
                >
                  Squishes
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-[#bbb5ae] hover:text-white transition-colors duration-200"
                >
                  Novelty Items
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-[#bbb5ae] hover:text-white transition-colors duration-200"
                >
                  All Products
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-[#bbb5ae]">
                <Mail className="w-4 h-4" />
                <span>sales@thinkooltoys.com</span>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-[#bbb5ae] hover:text-white transition-colors duration-200"
                >
                  Contact Form
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-[#bbb5ae] hover:text-white transition-colors duration-200"
                >
                  Newsletter
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-[#bbb5ae] text-sm">
              © {currentYear} Thinkkool Toys. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-[#bbb5ae] hover:text-white transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="text-[#bbb5ae] hover:text-white transition-colors duration-200">
                Terms of Service
              </a>
              <a href="#" className="text-[#bbb5ae] hover:text-white transition-colors duration-200">
                Shipping Info
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
